import React from "react";

import "../index.css";

export default function PersonDetails(props) {
  const form = props.form;
  const personErrors = props.personErrors;
  const setPersonErrors = props.setPersonErrors;

  const onSubmitHandler = () => {
    const postcodeRegEx = new RegExp(/^[0-9]+$/);
    const emailRegex = new RegExp(/.+@.+\..+/);

    const errors = {};

    if (form.address_line_1.trim() === "") {
      errors.address_line_1 = "Address Line 1 cannot be empty";
    }
    if (form.address_line_1.trim().length < 4) {
      errors.address_line_1 = "Address Line 1 cannot be less than 4 characters";
    }
    if (form.suburb.trim() === "") {
      errors.suburb = "Suburb cannot be empty";
    }
    if (form.suburb.trim().length < 2) {
      errors.suburb = "Suburb cannot be less than 2 characters";
    }
    if (!postcodeRegEx.test(form.postcode)) {
      errors.postcode = "Postcode must be numeric";
    }
    if (form.name.trim().length < 4) {
      errors.name = "Name cannot be less than 4 characters";
    }
    if (form.email.trim() === "") {
      errors.email = "Email cannot be empty";
    }
    if (!emailRegex.test(form.email)) {
      errors.email = `Email must be a valid email address`;
    }
    if (form.postcode.trim() === "") {
      errors.postcode = "Postcode cannot be empty";
    }

    setPersonErrors(errors);

    if (Object.keys(errors).length === 0) {
      props.nextStep();
    }
  };

  return (
    <div>
      <h4 className="text-2xl font-semibold">Payment Details</h4>
      <p className="leading-relaxed mt-1 text-gray-600 mb-10">
        Enter the details of the person purchasing the form.
      </p>

      <form className="space-y-4">
        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">

          <div className="w-full px-2 md:w-1/2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="name"
            >
              Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className={
                personErrors.name
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              placeholder="Name"
              name="name"
              onChange={props.handleChange("name")}
              defaultValue={form.name}
            />
            <p className=" text-red-600 text-xs mt-2">{personErrors.name}</p>
          </div>
          <div className="w-full px-2 md:w-1/2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="email"
            >
              Email <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className={
                personErrors.email
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              placeholder="Email"
              name="email"
              onChange={props.handleChange("email")}
              defaultValue={form.email}
            />
            <p className=" text-red-600 text-xs mt-2">{personErrors.email}</p>
          </div>
        </div>

        <div className="flex flex-wrap">
          <div className="w-full">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="address_line_1"
            >
              Address Line 1 <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className={
                personErrors.address_line_1
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              placeholder="Address Line 1"
              name="address_line_1"
              onChange={props.handleChange("address_line_1")}
              defaultValue={form.address_line_1}
            />
            <p className=" text-red-600 text-xs mt-2">
              {personErrors.address_line_1}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div className="w-full px-2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="address_line_2"
            >
              Address Line 2
            </label>
            <input
              type="text"
              className="border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              placeholder="Address Line 2"
              name="address_line_2"
              onChange={props.handleChange("address_line_2")}
              defaultValue={form.address_line_2}
            />
          </div>
        </div>
        <div className="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div className="w-full px-2 md:w-1/2">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="suburb"
            >
              Suburb <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className={
                personErrors.suburb
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              placeholder="Suburb"
              name="suburb"
              onChange={props.handleChange("suburb")}
              defaultValue={form.suburb}
            />
            <p className=" text-red-600 text-xs mt-2">{personErrors.suburb}</p>
          </div>
          <div className="w-full px-2 md:w-1/4">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="state"
            >
              State  <span className="text-red-500">*</span>
            </label>
            <select
              onChange={props.handleChange("state")}
              className="border-0 px-3 py-3 text-gray-700 rounded text-xs shadow focus:outline-none focus:ring w-full"
              defaultValue={form.state}
            >
              <option value="WA">WA</option>
              <option value="NT">NT</option>
              <option value="SA">SA</option>
              <option value="VIC">VIC</option>
              <option value="NSW">NSW</option>
              <option value="QLD">QLD</option>
              <option value="ACT">ACT</option>
              <option value="TAS">TAS</option>
            </select>
          </div>
          <div className="w-full px-2 md:w-1/4">
            <label
              className="block uppercase text-gray-700 text-xs font-bold mb-2"
              htmlFor="postcode"
            >
              Postcode <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className={
                personErrors.postcode
                  ? " border-red-500 border-x border-y px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
                  : "border-0 px-3 py-3 text-gray-700 bg-gray-50 rounded text-xs shadow focus:outline-none focus:ring w-full"
              }
              placeholder="Post Code"
              name="postcode"
              maxLength={4}
              onChange={props.handleChange("postcode")}
              defaultValue={form.postcode}
            />
            <p className=" text-red-600 text-xs mt-2">
              {personErrors.postcode}
            </p>
          </div>
        </div>
      </form>

      <div className="text-center flex justify-between mt-6 ">
        <button
          className="text-white bg-black focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          type="button"
          onClick={props.prevStep}
        >
          Back
        </button>
        <button
          className="text-white bg-[#3059a9] focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          type="button"
          onClick={onSubmitHandler}
        >
          Next
        </button>
      </div>
    </div>
  );
}
